import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { SUPERADMIN_USER_ID } from "constants/constants";

interface ProtectedEvaRouteProps {
  children: React.ReactNode;
}

const ProtectedEvaRoute: React.FC<ProtectedEvaRouteProps> = ({ children }) => {
  const { userId } = useUser();

  // Check if the current user ID matches the allowed UUID
  const isAuthorized = userId === SUPERADMIN_USER_ID;

  if (!isAuthorized) {
    // Redirect to home page if not authorized
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedEvaRoute;
